import { z } from 'zod';

export const FetchUrlToolName = 'fetchUrl' as const;

/**
 * FetchUrl tool contract. Lets the agent read a specific web page —
 * category pages, buying guides, or links the operator put into the
 * customization prompt — and verify that links it wants to share actually
 * resolve.
 */
export const fetchUrlArgsSchema = z.object({
  url: z
    .string()
    .url()
    .describe(
      'Absolute http(s) URL to fetch. Use URLs from tool results, the conversation, or the shop instructions — never construct or guess URLs.',
    ),
  mode: z
    .enum(['content', 'check'])
    .nullish()
    .describe(
      '"content" (default) returns the readable text of the page. "check" only verifies the link resolves (status check without downloading the page) — use it before sharing a link you have not seen in a tool result this conversation.',
    ),
  pageOffset: z.coerce
    .number()
    .int()
    .min(0)
    .nullish()
    .describe(
      '0-based first page to read for documents (PDF, Word, PowerPoint). Default 0. Use the pageOffset suggested in a previous result when its footer reported hasMore=true.',
    ),
  pageLimit: z.coerce
    .number()
    .int()
    .min(1)
    .max(20)
    .nullish()
    .describe(
      'Pages to read per call for documents. Default 20, or 8 for PDFs when the PDF page reader is enabled. Max 20.',
    ),
});

export const fetchUrlContentSchema = z.string();

export type FetchUrlArgs = z.infer<typeof fetchUrlArgsSchema>;
export type FetchUrlContent = z.infer<typeof fetchUrlContentSchema>;
